import { render, staticRenderFns } from "./ColorFormatter.vue?vue&type=template&id=55e46df7&functional=true"
import script from "./ColorFormatter.vue?vue&type=script&lang=js"
export * from "./ColorFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports